import {Component, OnInit} from '@angular/core';
import {AbstractEditOrmComponent} from "../../AbstractEditOrmComponent";
import {Especime} from "../../../../domain/Especime";
import {
  Acionamento,
  AtributoEspecime,
  ClasseEtaria,
  Destino,
  Dinamica,
  EstagioMaturacao,
  FormaRegistro,
  Funcao,
  Grupo,
  Sexo,
  SimNaoAparente,
  SituacaoEspecime,
  Tempo
} from "../../../../domain/enums";
import {Comportamento} from "../../../../domain/Comportamento";
import {Pessoa} from "../../../../domain/Pessoa";
import {ControleExbicao} from "./ControleExbicao";
import {TipoMarcacao} from "../../../../domain/TipoMarcacao";
import {Utils} from "../../../../services/Utils";
import {EnumSincronizacao} from "../../../../domain/EnumSincronizacao";
import {Arquivo} from "../../../../domain/Arquivo";

@Component({
  selector: 'app-pessoa',
  templateUrl: './edit-especime.component.html',
  styleUrls: ['./edit-especime.component.scss'],
})
export class EditEspecimeComponent extends AbstractEditOrmComponent<Especime> implements  OnInit{
  agenciavel = true
  dinamicas = Object.values(Dinamica)
  sexos = Object.values(Sexo)
  classesEtarias = Object.values(ClasseEtaria)
  tempos = Object.values(Tempo)
  acionamentos = Object.values(Acionamento)
  simNaoAparentemente = Object.values(SimNaoAparente)
  estagiosMaturacao = Object.values(EstagioMaturacao)
  estados = Object.values(SituacaoEspecime)
  formasRegistros = Object.values(FormaRegistro)
  destinos = Object.values(Destino)
  comportamentos : Comportamento[]= []
  pessoas: Pessoa[] =[]
  tiposMarcacoes: TipoMarcacao[] = []
  target = Especime
  urlListagem = '/registro/especime'
  override relations =['comportamento','guia','observadores','instituicaoDepositaria','tipoMarcacao',
    'meteorologias','arquivos','taxon','bioma','monitoramento','monitoramento.metodos',"metodoAmostragem"]
  protected ctlExibir = new ControleExbicao()


  get guias(): Pessoa[]{
    return this.pessoas.filter(p=> p.funcoes?.includes(Funcao.GUIA))
  }

  get observadores(): Pessoa[]{
    return this.pessoas.filter(p=> p.funcoes?.includes(Funcao.OBSERVADOR))
  }

  get instituicoes(): Pessoa[]{
    return this.pessoas.filter(p=> p.funcoes?.includes(Funcao.INSTITUICAO))
  }

  override novaEntidade(): Especime {
    const nova = new Especime()
    nova.agencia_sigla = this.getSiglaAgencia()
    nova.dataHora = Utils.dataHoraAtual();
    nova.dinamicaSocial = Dinamica.SOLITARIO
    nova.individuos = 1
    nova.arquivos = []
    nova.formasRegistro = []
    nova.meteorologias = []
    nova.observadores = []
    return nova
  }

  constructor() {
    super()
    this.carregaListas().then()
    this.ctlExibir.route = this.route
  }

  override async loadEntity(id: any): Promise<void> {
    this.entidade = await this.service.findOneOrFail({
        where:{id: id},
        relations: this.relations
     })
    if(!this.entidade)
      await this.message('Entidade não encontrada', 'erro')
  }
  exibir(nomeCampo: AtributoEspecime):boolean {
    return this.ctlExibir.exibir(nomeCampo, this.entidade)
  }

  async carregaListas() {
    const pessoaRepo = this.ds.getRepository(Pessoa)
    this.comportamentos = await this.ds.getRepository(Comportamento).find({order: {nome: "asc"}})
    this.pessoas = await pessoaRepo.find({order: {nome: "asc"}})
    this.tiposMarcacoes = await this.ds.getRepository(TipoMarcacao).find({order: {nome: "asc"}})
  }

  protected readonly AtributoEspecime = AtributoEspecime;

  // protected override async saveInternal(): Promise<void> {
  //   this.entidade.situacao = EnumSincronizacao.ENVIAR
  //   await super.saveInternal()
  // }

  protected override async saveInternal(): Promise<void> {
    this.entidade.situacao= this.entidade.monitoramento ?  EnumSincronizacao.INCOMPLETO :   EnumSincronizacao.ENVIAR

    console.log('arquivos', this.entidade.arquivos)
    if(this.entidade.arquivos && this.entidade.arquivos.length > 0 ) {
      const repo = this.ds.getRepository(Arquivo)
      for (const m of this.entidade.arquivos) {
        m.situacao = this.entidade.monitoramento ?  EnumSincronizacao.INCOMPLETO :   EnumSincronizacao.ENVIAR
        await repo.save(m)
      }
    }
    await super.saveInternal();
  }
}
